import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useDatabaseChartsDataContext } from './hooks/useDatabaseChartsDataContext';

export const FamiliesRegister = () => {
    const { chartData } = useDatabaseChartsDataContext();

    return (
        <SimpleBars
            title={'Cadastramento de Famílias'}
            horizontal={false}
            subtitles={chartData?.familiesRegister?.map((item) => item.description)}
            values={chartData?.familiesRegister?.map((item) => item.total  ||  0)}
        />
    );
};
